import { Icon } from "@iconify/react";
import classes from "./ServicesPage.module.css";

const CONTACT_EMAIL = "tribalrunninggalway@gmail.com";

const services = [
    { icon: "mdi:access-point", label: "RFID chip timing for races of all sizes" },
    { icon: "mdi:monitor-dashboard", label: "Live online race results" },
    { icon: "mdi:barcode", label: "Race numbers, barcode printing and chip allocation" },
    { icon: "mdi:clipboard-check-outline", label: "Race administration and event support" },
    { icon: "mdi:certificate-outline", label: "Fast online results and downloadable certificates" },
    { icon: "mdi:timer-outline", label: "Track & Field electronic timing" },
    { icon: "mdi:flag-checkered", label: "Finish line management and post-race results" },
    { icon: "mdi:handshake-outline", label: "Support before, during and after your event" },
];

const comingSoon = [
    { icon: "mdi:account-star-outline", label: "Personalised athlete result pages" },
    { icon: "mdi:video-outline", label: "Finish-line video integration" },
    { icon: "mdi:podium-gold", label: "Enhanced live leaderboards" },
    { icon: "mdi:rocket-launch-outline", label: "Additional race management and digital event services" },
];

export default function ServicesPage() {
    return (
        <div className={classes.page}>
            <section className={classes.hero}>
                <p className={classes.eyebrow}>Tribal Running Services</p>
                <h1 className={classes.title}>Professional Race Timing &amp; Event Services</h1>
                <p className={classes.intro}>
                    Tribal Running Services provides professional race timing and event
                    support for road races, charity events, club races, schools and
                    athletics competitions throughout Ireland.
                </p>
                <p className={classes.intro}>
                    We combine reliable timing technology with practical race-day
                    experience to deliver accurate results, dependable service and a
                    great experience for organisers and participants alike.
                </p>
            </section>

            <section className={classes.services}>
                <h2 className={classes.sectionHeading}>Our Services</h2>
                <div className={classes.servicesGrid}>
                    {services.map(({ icon, label }) => (
                        <div className={classes.serviceCard} key={label}>
                            <Icon icon={icon} width={36} height={36} className={classes.serviceIcon} />
                            <p>{label}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className={classes.why}>
                <h2 className={classes.sectionHeading}>Why Choose Tribal Running Services?</h2>
                <p>
                    As runners ourselves, we understand what matters on race day. Our
                    focus is on accuracy, reliability, communication and delivering a
                    professional service from the first enquiry to the final published
                    result.
                </p>
                <p>
                    Whether your event has 100 participants or several thousand, our
                    goal is always the same:
                </p>
                <p className={classes.tagline}>
                    Professional Timing. Reliable Results. Exceptional Service.
                </p>
            </section>

            <section className={classes.comingSoon}>
                <h2 className={classes.comingSoonHeading}>Coming Soon</h2>
                <div className={classes.comingSoonGrid}>
                    {comingSoon.map(({ icon, label }) => (
                        <div className={classes.comingSoonItem} key={label}>
                            <Icon icon={icon} width={22} height={22} className={classes.comingSoonIcon} />
                            <p>{label}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className={classes.cta}>
                <div>
                    <h2>Planning an event?</h2>
                    <p>
                        Get in touch to discuss timing and event services for your next
                        race.
                    </p>
                </div>
                <a href={`mailto:${CONTACT_EMAIL}`} className={classes.ctaButton}>
                    Get a quote
                </a>
            </section>
        </div>
    );
}
